import React from 'react';

/**
 * Tone/plot refinement chips for the AI recommendations. These steer the AI's
 * judgement only (re-ranking its picks in place) — they are NOT hard filters.
 * Structural filters (streamer, release year, type) live in the FilterBar and
 * re-query the whole result set instead.
 *
 * Props:
 *   selected — array of selected chip keys ("group:value")
 *   onToggle — (chip) => void   chip = { group, value, label }
 *   tone     — 'light' (movies) | 'dark' (manhua)
 */
const TONE_CHIPS = [
  { group: 'vibe', value: 'a lighter, more feel-good tone', label: '😊 Lighter' },
  { group: 'vibe', value: 'a darker, more intense tone', label: '🌑 Darker' },
  { group: 'vibe', value: 'less violence and gore', label: '🕊️ Less violent' },
  { group: 'vibe', value: 'more fast-paced and action-heavy', label: '💥 More action' },
  { group: 'plot', value: 'matching the plot and premise closely', label: '🧩 Closer to the plot' },
];

const RefineChips = ({ selected = [], onToggle, tone = 'light' }) => {
  const dark = tone === 'dark';
  const onCls = dark ? 'bg-rose-500 text-white border-rose-500' : 'bg-purple-600 text-white border-purple-600';
  const offCls = dark
    ? 'bg-white/5 text-zinc-300 border-white/10 hover:bg-white/10 hover:text-white'
    : 'bg-gray-100 text-gray-600 border-gray-200 hover:bg-gray-200 hover:text-gray-900';

  return (
    <div className="flex flex-wrap gap-2">
      {TONE_CHIPS.map((chip) => {
        const id = `${chip.group}:${chip.value}`;
        const isOn = selected.includes(id);
        return (
          <button
            key={id}
            onClick={() => onToggle && onToggle(chip)}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-all ${isOn ? onCls : offCls}`}
          >
            {chip.label}
          </button>
        );
      })}
    </div>
  );
};

export default RefineChips;
